import * as yup from "yup";
import { useQuery } from "@tanstack/react-query";
import { HTTP_ENDPOINTS, QUERY_KEYS } from "../../consts/api";
import { http } from "../../services/HttpService";
import { removeNullishFromShape } from "../../utilities/general";

const requestSchema = yup.object({
  clinicId: yup.number().nullable(),
});

const responseSchema = yup.object({
  totalLiability: yup.string().required(),
});

const composeResponse = (res) => ({
  totalLiability: res?.data?.data?.total_liability,
});

const createShortTermLiabilityTotalQueryKey = (...args) => [
  QUERY_KEYS.shortTermLiabilityTotal,
  ...args,
];

export const useShortTermLiabilityTotalQuery = ({
  payload = {},
  options = {},
} = {}) => {
  const req = requestSchema.validateSync(payload, {
    strict: true,
  });

  return useQuery(
    createShortTermLiabilityTotalQueryKey(req.clinicId),
    async () => {
      const res = await http.post(
        HTTP_ENDPOINTS.shortTermLiabilityTotal(),
        removeNullishFromShape({
          clinic_id: req.clinicId,
        }),
      );

      return responseSchema.validateSync(composeResponse(res), {
        strict: true,
      });
    },
    options,
  );
};
